import React from 'react';
import { SgDocumentDetails, CepConstants } from 'saga-cep-specific-components';
import { useSgTrackPageName } from 'saga-modules';
import { renderContentFromMetadata } from '@jutro/uiconfig';

import SgCepSideMenu from 'sg-cep-side-menu';
import metadata from './DocumentsPage.metadata.json5';
import './DocumentsPage.messages';

function DocumentsPage() {
    const overrideProps = {};

    useSgTrackPageName(CepConstants.PAGE_NAMES.DOCUMENTS);

    const resolvers = {
        resolveComponentMap: {
            SgDocumentDetails,
            SgCepSideMenu
        }
    };

    const renderedContentFromMetadata = renderContentFromMetadata(
        metadata.pageContent,
        overrideProps,
        resolvers
    );

    return (
        <div>
            {renderedContentFromMetadata}
        </div>
    );
}

export default DocumentsPage;
